import { WP_API_BASE } from '../../util/constants'

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  posts: [],
  pageCount: 1,
  search: '',
  categoriesFilter: [],
  activeArea: [],
  datesFilter: [],
  activeDate: '',
}

const LOAD_PUBLICATIONS_DATA = 'LOAD_PUBLICATIONS_DATA'
const LOAD_PUBLICATIONS_DATA_SUCCESS = 'LOAD_PUBLICATIONS_DATA_SUCCESS'
const LOAD_PUBLICATIONS_DATA_FAILURE = 'LOAD_PUBLICATIONS_DATA_FAILURE'

export default (state = {}, action) => {
  const { type, payload } = action

  const prevState = () => {
    return state.hasOwnProperty(payload.id) ? state[payload.id] : initialState
  }

  switch (type) {
    case LOAD_PUBLICATIONS_DATA:
      return {
        ...state,
        [payload.id]: {
          ...prevState(),
          isLoading: true,
        },
      }

    case LOAD_PUBLICATIONS_DATA_SUCCESS:
      return {
        ...state,
        [payload.id]: {
          ...prevState(),
          isLoading: false,
          isLoaded: true,
          posts: [...payload.posts],
          pageCount: payload.pageCount,
          search: payload.search,
          error: false,
          categoriesFilter: [...payload.categoriesFilter],
          activeArea: [...payload.activeArea],
          datesFilter: [...payload.datesFilter],
          activeDate: payload.activeDate,
        },
      }

    case LOAD_PUBLICATIONS_DATA_FAILURE:
      return {
        ...state,
        [payload.id]: {
          ...prevState(),
          isLoading: false,
          error: payload.error,
        },
      }

    default:
      return state
  }
}

export const loadPosts = ({
  id,
  termId,
  lang,
  showAll,
  pageNumber,
  search = '',
  activeArea = [],
  activeDate,
}) => dispatch => {
  dispatch({ type: LOAD_PUBLICATIONS_DATA, payload: { id } })

  // Rest API Params
  const params = {
    paged: pageNumber,
    //category: activeArea,
  }

  activeArea ? (params['activeArea'] = activeArea) : ''
  termId ? (params['term_id'] = termId) : ''
  lang ? (params['lang'] = lang) : ''
  showAll ? (params['show_all'] = showAll) : ''
  search ? (params['search'] = search) : ''
  activeDate ? (params['activeDate'] = activeDate) : ''

  let url_params = '/'
  if (params) {
    let i = 0
    for (let key in params) {
      params.hasOwnProperty(key)
        ? (url_params += (i === 0 ? '?' : '&') + key + '=' + params[key])
        : false
      i++
    }
  }

  fetch(`${WP_API_BASE}publications${url_params}`, {
    method: 'GET',
  })
    .then(response => {
      if (response.ok && response.status === 200) {
        return response.json()
      }
      throw new Error(response.statusText)
    })
    .then(data => {
      dispatch({
        type: LOAD_PUBLICATIONS_DATA_SUCCESS,
        payload: {
          id,
          posts: data.publications,
          pageCount: data.pageCount,
          search,
          categoriesFilter: data.categories_filter,
          activeArea,
          datesFilter: data.dates_filter,
          activeDate,
        },
      })

      return data
    })
    .catch(error => {
      if (process.env.NODE_ENV === 'development') {
        console.error(error) //eslint-disable-line
      }
      dispatch({
        type: LOAD_PUBLICATIONS_DATA_FAILURE,
        payload: {
          id,
          error,
        },
      })
    })
}
